import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Common";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { const r = await api.post("/auth/forgot-password", { email: email.trim() }); setMsg(r.data.message); } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-6 py-12">
      <div className="w-full max-w-sm fade-up" data-testid="forgot-password-page">
        <Logo className="h-12" />
        <h2 className="mt-10 font-display text-3xl font-extrabold">Password dimenticata</h2>
        <p className="mt-2 text-sm text-muted-foreground">Inserisci l'email del tuo account: ti mandiamo un link per sceglierne una nuova, valido 1 ora.</p>
        {msg ? (
          <div className="mt-8 space-y-4">
            <div className="border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-800" data-testid="forgot-password-sent">{msg}</div>
            <Link to="/login" className="text-sm underline" data-testid="forgot-back-login">Torna all'accesso</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div><Label className="micro-label">Email</Label><Input type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12" data-testid="forgot-email-input" /></div>
            {error && <div className="border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="forgot-error">{error}</div>}
            <Button type="submit" disabled={busy} className="h-12 w-full text-base" data-testid="forgot-submit">{busy ? "Invio…" : "Mandami il link"}</Button>
            <Link to="/login" className="block text-center text-sm underline">Torna all'accesso</Link>
          </form>
        )}
      </div>
    </div>
  );
}
